import { Col, Row } from 'antd';
import React, { useCallback, useMemo } from 'react';

import Text from '../../components/Text';
import { GUTTER, STYLES } from './constants';
import RateSection from './RateSection';

const FIXED_COMPONENT_CONFIG = [
  { key: 'depreciation', translationKey: 'depreciation', boundsKey: 'fix_depreciation' },
  { key: 'taxFees', translationKey: 'taxFees', boundsKey: 'fix_taxes_fees' },
  { key: 'insurance', translationKey: 'insurance', boundsKey: 'fix_insurance' },
];

const VARIABLE_COMPONENT_CONFIG = [
  { key: 'maintenance', translationKey: 'maintenance', boundsKey: 'var_maintenance_per_mile' },
  { key: 'repairs', translationKey: 'repairs', boundsKey: 'var_repairs_per_mile' },
  { key: 'fuelPerMile', translationKey: 'fuelPerMile', boundsKey: 'var_fuel_per_mile' },
];

const FavrRateResultsPanel = props => {
  const { t, countryCode = 'US', results = {}, summary } = props;

  const { variableRate, variableComponents = {}, fixedRate, fixedComponents = {} } = results;

  const fieldsToCheck = useMemo(() => {
    const fieldMappings = {
      fixed_rate: { value: fixedRate, path: 'fixedRate' },
      variable_rate: { value: variableRate, path: 'variableRate' },
      fix_depreciation: {
        value: fixedComponents.depreciation,
        path: 'fixedComponents.depreciation',
      },
      fix_taxes_fees: { value: fixedComponents.taxFees, path: 'fixedComponents.taxFees' },
      fix_insurance: { value: fixedComponents.insurance, path: 'fixedComponents.insurance' },
      var_maintenance_per_mile: {
        value: variableComponents.maintenance,
        path: 'variableComponents.maintenance',
      },
      var_repairs_per_mile: {
        value: variableComponents.repairs,
        path: 'variableComponents.repairs',
      },
      var_fuel_per_mile: {
        value: variableComponents.fuelPerMile,
        path: 'variableComponents.fuelPerMile',
      },
    };

    return Object.keys(fieldMappings);
  }, [fixedRate, variableRate, fixedComponents, variableComponents]);

  const getBounds = useCallback(
    fieldKey => {
      if (!summary?.rates?.[fieldKey]) {
        return null;
      }

      return summary.rates[fieldKey];
    },
    [summary],
  );

  if (!results || (fixedRate === undefined && variableRate === undefined)) {
    return (
      <div style={STYLES.emptyState}>
        <Text type="secondary">{t('noResultsAvailable')}</Text>
      </div>
    );
  }

  return (
    <Row gutter={GUTTER.section} justify="space-between">
      <Col xs={24} lg={12} xl={11}>
        <RateSection
          title={t('fixedRate_perMonth')}
          mainRate={fixedRate}
          mainBoundsKey="fixed_rate"
          components={fixedComponents}
          componentConfig={FIXED_COMPONENT_CONFIG}
          fieldsToCheck={fieldsToCheck}
          getBounds={getBounds}
          t={t}
          countryCode={countryCode}
        />
      </Col>
      <Col xs={24} lg={12} xl={11}>
        <RateSection
          title={t('variableRate_perMile')}
          mainRate={variableRate}
          mainBoundsKey="variable_rate"
          components={variableComponents}
          componentConfig={VARIABLE_COMPONENT_CONFIG}
          fieldsToCheck={fieldsToCheck}
          getBounds={getBounds}
          t={t}
          countryCode={countryCode}
        />
      </Col>
    </Row>
  );
};

export default FavrRateResultsPanel;
